
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class TooltipIcon extends Vue {
  // 📦 The icon that needs to be displayed
  @Prop({ default: "mdi-help-circle" })
  public icon?: string;

  // 📦 The size of the icon
  @Prop({ default: 16 })
  public size?: number;

  // 📦 The color of the icon
  @Prop({ default: "grey lighten-1" })
  public color?: string;

  // 📦 The tooltip body that will appear on hover
  @Prop()
  public tooltip!: string;

  // 📦 The tooltip width
  @Prop({ default: 400 })
  public popupWidth!: number;
}
